import { v4 as uuidv4 } from 'uuid';
import { apis } from './../../globals/resources';
import * as Type from './types';

export default class StatisticsApi {
  isNewSession: boolean;

  private baseUrl = apis.webcometUrl;
  private sessionId: string;
  private disabled = false;
  public viewHasBeenTracked = false;

  private modelType: string;
  private modelIdentifier: string;
  private source: string;

  constructor(
    modelType: string,
    modelIdentifier: string,
    source: Type.WebcometComponent
  ) {
    this.modelType = modelType;
    this.modelIdentifier = modelIdentifier;
    this.source = source;

    this.isNewSession = false;

    const storedSessionId = window.sessionStorage.getItem(this.getSessionKey());
    if (storedSessionId === null) {
      this.sessionId = this.createSession();
    } else {
      this.sessionId = storedSessionId;
    }
  }

  disable(): void {
    this.disabled = true;
  }

  private getSessionKey(): string {
    return `urn:${this.source}:${this.modelType}:${this.modelIdentifier}`;
  }

  private createSession(): string {
    const sessionId = uuidv4();
    window.sessionStorage.setItem(this.getSessionKey(), sessionId);
    this.isNewSession = true;

    return sessionId;
  }

  async track(
    type: Type.StatType,
    payload: Record<any, any>
  ): Promise<Response> {
    if (this.disabled) {
      return;
    }

    if (
      !this.viewHasBeenTracked &&
      this.isNewSession &&
      type !== Type.StatType.View
    ) {
      this.viewHasBeenTracked = true;
      this.track(Type.StatType.View, {
        url: window.location.href.split('?')[0],
        referrer: document.referrer,
        language: payload.language,
      });
    }

    const data = {
      model: this.modelType,
      identifier: this.modelIdentifier,
      type: type,
      source: this.source,
      session: this.sessionId,
      payload: payload,
    };

    return window.fetch(`${this.baseUrl}/api/internal/statistics`, {
      method: 'post',
      mode: 'cors',
      headers: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });
  }
}
